import { render } from "./BanobagiBannerCarousel.vue?vue&type=template&id=7fdf0c52&scoped=true"
import script from "./BanobagiBannerCarousel.vue?vue&type=script&lang=js"
export * from "./BanobagiBannerCarousel.vue?vue&type=script&lang=js"

import "./BanobagiBannerCarousel.vue?vue&type=style&index=0&id=7fdf0c52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fdf0c52"]])

export default __exports__